{
  "navigation": {
    "dashboard": "الرئيسية"
  },
  "user": {
    "notifications": "الإشعارات"
  },
  "nav": {
    "mainNavigation": "التنقل الرئيسي",
    "toggleSidebar": "إظهار/إخفاء القائمة الجانبية",
    "toggleSidebarHint": "إظهار أو إخفاء القائمة",
    "boxes": "الصناديق",
    "currencies": "العملات",
    "treasury": "الخزينة",
    "reports": "تقارير وإحصائيات",
    "sectionSettings": "الإعدادات",
    "settings": "الإعدادات",
    "exchangeSettings": "إعدادات الصرف",
    "users": "المستخدمين",
    "groups": "المجموعات",
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة"
  },
  "brand": "المسافر"
}
